export default __webpack_public_path__ + "static/media/330_dummy2016-kuenstler02-mobile-de.b0b9f2b0.png";